import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import React, { useEffect } from "react";
import "./style.css";
import { Select } from "antd";
import TableComplex from "../../vapor/tableComplex";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

const Option = Select.Option;

const ContiIvaTable = ({
  contiIva,  
  regimeId,
  showvatCollectability,
  totalTaxable,
  setTotalTaxable,
  totalTax,
  setTotalTax
}) => {

  const regimes = useSelector(state => state.precog.vat.regimes);

  useEffect(() => {
    let newTaxes = [];
    let taxable = 0;
    let taxes = 0;
    
    if (contiIva) {
      contiIva.map(el => {
        newTaxes.push({ id: el.accountId, tax: el.tax });
        taxable = taxable + el.taxable;
        taxes = taxes + el.tax;
        return newTaxes;
      });
    }
    setTotalTaxable(taxable);
    setTotalTax(taxes);    
  }, [contiIva]);

  const renderTableRow = conto => {
    const regimeVal = regimes?.list?.find(x => x.id === conto.regimeId)?.description;    
    return {
      key: conto?.rowId,
      conto: conto,      
      regime: regimeId === "MULTI" && <div style={{ paddingLeft: 4 }}>{
        regimeVal ? regimeVal?.charAt(0)?.toUpperCase() + regimeVal?.slice(1)?.toLowerCase() : conto.regimeId
      }</div>,
      vatCollectability: (
        <Select
          id="pre-cog-detail-input-5"
          className="conti-iva-chargeability"
          label=""
          value={conto.vatCollectability}
          placeholder={"Tipo di esigibilità"}
          onChange={val => {
            let newArray = [];
            contiIva.map(el => {
              if (el.accountId === conto.accountId) {
                return newArray.push({ ...el, vatCollectability: val });
              } 
              return newArray.push(el);
              
            });
          }}
        >
          <Option key={"S"} value="S">
            <FormattedMessage id="preCog.header.splitPayment" />
          </Option>
          <Option key={"D"} value="D">
            <FormattedMessage id="preCog.header.deferredVat" />
          </Option>
        </Select>
      ),
      imponibile: `${numeral(Math.abs(conto.taxable)).format("0,0.00")}€`,
      aliquota: <div style={{fontWeight: "normal"}}> {conto.rate} </div>,
      imposta: <div style={{fontWeight: "normal"}}>{numeral(Math.abs(conto.tax)).format("0,0.00")}€</div>,
      detraibilità: <div style={{ fontWeight: "normal" }}>
        {conto.deductibility !== "0.00" ? `${numeral(Math.abs(conto.deductibility)).format("0,0.00")}€` : "-"}
      </div>,
      removeConto: <div>&nbsp;</div>
    };
  };

  const buildDataSource = () => {
    return contiIva?.map((conto, key) => renderTableRow(conto));
  };

  const renderSummary = () => {
    let itemsRet = [<div key={"emptySummary"}>&nbsp;</div>];

    if (showvatCollectability) {
      itemsRet.push(<div>&nbsp;</div>);
    }

    itemsRet = [
      ...itemsRet,
      <div key={`preCog-detail-table-summary-totals_${totalTax}`} className="preCog-detail-table-summary-totals">
        {numeral(Math.abs(totalTaxable)).format("0,0.00")}€
      </div>,
      <div  key={`preCog-detail-table-summary-totals2_${totalTax}`} className="preCog-detail-table-summary-totals">
        &nbsp;
      </div>,
      <div  key={`preCog-detail-table-summary-total3_${totalTax}`} className="preCog-detail-table-summary-totals">
        {numeral(Math.abs(totalTax)).format("0,0.00")}€
      </div>,
      <div  key={`preCog-detail-table-summary-totals4_${totalTax}`} className="preCog-detail-table-summary-totals">
        &nbsp;
      </div>,
      <div
        key={`preCog-detail-table-summary-totals5_${totalTax}`}
        style={{ textAlign: "center" }}
        className="preCog-detail-table-summary-totals"
      >
        Totale: {numeral(Math.abs(totalTaxable + totalTax)).format("0,0.00")}€
      </div>,
      <div  key={`preCog-detail-table-summary-totals6_${totalTax}`} style={{ textAlign: "end", paddingRight: 8 }}>
        <FontAwesomeIcon
          icon={["fas", "check"]}
          className="preCog-detail-check-icon"
        />
      </div>
    ];

    return itemsRet;
  };
  
  let columnsContiIva = [
    regimeId === "MULTI" ? 
      {
        title: "Regime",
        width: "25%",
        dataIndex: "regime",
        key: "regimeId"
      } : 
      {
        title: null,
        width: "1px",
        dataIndex: "regime",
        key: "regime"
      },
    {
      title: "Imponibile",
      width: regimeId === "MULTI" ? "15%" : "25%",
      dataIndex: "imponibile",
      key: "imponibile"
    },
    {
      title: "Aliquota",
      width: regimeId === "MULTI" ? "15%" : "25%",
      dataIndex: "aliquota",
      key: "aliquota"
    },
    {
      title: "Imposta",
      width: regimeId === "MULTI" ? "10%" : "15%",
      dataIndex: "imposta",
      key: "imposta"
    },
    {
      title: "Detraibilità",
      width: "10%",
      dataIndex: "detraibilità",
      key: "deductibility"
    },
    {
      title: "",
      width: "23%",
      dataIndex: "emptyRow",
      key: "emptyRow"
    },
    {
      title: "",
      width: "2%",
      dataIndex: "removeConto",
      key: "removeConto"
    }
  ];

  return (
    <div className="conti-iva-table">
      <TableComplex
        summary={renderSummary()}
        dataSource={buildDataSource()}
        columns={columnsContiIva}
      />
    </div>
  );
};

export default ContiIvaTable;
